import React, { useState} from 'react'
import './Fancybet1.css';

const tabs = [
  "ALL",
  "Fancy",
  "Line Markets",
  "Ball by Ball",
  "Meter Markets",
  "Khado Markets",
];

const FancybetData=[
    {
        name:"SA Only 12th Over Runs 40",
        no: 13,
        yes: 17,
        minmax: "100 - 20000",
    },
    {
        name:"Fall of 3rd Wicket SA",
        no: 54,
        yes: 68,
        minmax: "100 - 20000",
    },
    {
        name:"SA 3rd Wicket Partnership",
        no: 120,
        yes: 180,
        minmax: "100 - 20000",
    },
    {
        name:"Temba Bavuma Runs Open Valid 2",
        no: 400,
        yes: 500,
        minmax: "100 - 20000",
    },
    {
        name:"Aiden Markram Runs 3",
        no: 680,
        yes: 800,
        minmax: "100 - 20000",
    },
    {
        name:"Temba Bavuma Runs Open Valid 2",
        no: "1,253",
        yes: "1,527",
        minmax: "100 - 20000",
    },
    {
        name:"Aiden Markram Runs 3",
        no: "1,243",
        yes: "1,427",
        minmax: "100 - 20000",
    },
];

const Fancybet1 = () => {
    const [activeTab, setActiveTab] = useState("ALL");
    const [showModal, setShowModal] = useState(false);
    const openinfomodele = () => setShowModal(true);
    const closeModal = () => setShowModal(false);
  return (
    <div className="fancy-container">
      <div className="switch-header">
        <button className="active">Fancy Bet </button>
        <button
          onClick={openinfomodele}
          style={{
            cursor: "pointer",
            marginRight: "5px",
            background: "#5b8847ff",
            border: "none",
            fontSize: "15px",
            color: "white",
            borderRadius: "0px 50px 0px 0px",
          }}
        >
          ⓘ
        </button>
        <button>Sportsbook </button>{" "}
        <button
          onClick={openinfomodele}
          style={{
            cursor: "pointer",
            marginRight: "5px",
            background: "#e559d9ff",
            border: "none",
            fontSize: "15px",
            color: "white",
            borderRadius: "0px 50px 0px 0px",
          }}
        >
          ⓘ
        </button>
        {/* <i className="info-icon">ℹ️</i> */}
      </div>

      <div className="tabs-container d-flex overflow-auto align-items-right px-2">
        {tabs.map((t, i) => (
          <button
            key={i}
            className={`fancytab-btn ${activeTab === t ? "active" : ""}`}
            onClick={() => setActiveTab(t)}
          >
            {t}
          </button>
        ))}
      </div>

      {/* Table */}
      <div className="table-responsive">
        <table className="table table-bordered fancy-table">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th className="no-coll" style={{ background: "#fb8ab5" }}>
                No
              </th>
              <th className="yes-coll" style={{ background: "#4ca6f7" }}>
                Yes
              </th>
              <th className="">Min/Max</th>
            </tr>
          </thead>

          <tbody>
            {FancybetData.map((row, index) => (
              <tr key={index}>
                <td className="market-name" style={{ background: "#ffff" }}>
                  {row.name}
                </td>
                <td>
                  <button className="book-btn">Book</button>
                </td>
                <td
                  className="no-coll back-cell1"
                  style={{ background: "#fb8ab5" }}
                >
                  <strong>{row.no}</strong>
                  <div className="small text-dark ">100</div>
                </td>
                <td
                  className="yes-coll lay-cell"
                  style={{ background: "#4ca6f7" }}
                >
                  <strong>{row.yes}</strong>
                  <div className="small text-dark">110</div>
                </td>
                <td className="">{row.minmax}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showModal && (
        <>
          <div className="modal-overlay" onClick={closeModal}></div>

          <div className="modal-box">
            <h3>Information</h3>

            <div className="modal-content">
              {/* Yahan aapka 1000 words ya table aa sakta hai */}
              <p>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. (yaha
                content scroll hoga)
              </p>

              {/* Example table */}
              <table border="1" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.from({ length: 50 }).map((_, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>Item {i + 1}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <button className="close-btn" onClick={closeModal}>
              ok
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Fancybet1
